import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private http: HttpClient) { }
  public url: string = `${environment.baseUrl}users`

  getToken() {
    return sessionStorage.getItem("auth_token");
  }


  Logout() {
    sessionStorage.clear();
  }

  ActiveUserLogout() {

    let authToken = sessionStorage.getItem('auth_token');

    let httpOptions =
    {
      headers: new HttpHeaders(
        {
          "Authorization": authToken,
          'user_type': '1'
        }
      )
    }

    return this.http.post(environment.baseUrl + "admin/logout", {}, httpOptions);
  }

}
